import { render, staticRenderFns } from "./SelectProgram.vue?vue&type=template&id=1ae17f23&scoped=true"
import script from "./SelectProgram.vue?vue&type=script&lang=js"
export * from "./SelectProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae17f23",
  null
  
)

export default component.exports